module.exports = __webpack_public_path__ + "img/changeFinish-2@2x.ffee46b.png";